export const CART_DIALOG_TYPE = {
  GENERAL_ERROR: 'GENERAL_ERROR',
  PAYPAL_INVALID_SHIPPING_ADDRESS: 'PAYPAL_INVALID_SHIPPING_ADDRESS',
} as const;
